module.exports = __webpack_public_path__ + "static/tecnologias-mobile-227d7ebe0f0ced6b45e7f8477ce75bf0.png";